import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box } from '@mui/material';

const ErrorComponent = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        justifyContent: 'center',
        fontFamily: tsoPqTheme.typography.openSans,
        color: tsoPqTheme.palette.customError.color_signal_error_error,
      }}
    >
      <h1>Authentication Failed</h1>
    </Box>
  );
};

export default ErrorComponent;
